import { render, staticRenderFns } from "./BwItemPrice.vue?vue&type=template&id=9bc24d86"
import script from "./BwItemPrice.vue?vue&type=script&lang=js"
export * from "./BwItemPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports